export function handleOuterNavigation(level, type) {
    const header = document.querySelector(".ux-iws-header") as HTMLElement;

    const dropdownContainer = document.querySelector(
        ".ux-iws-header__dropdown-container"
    ) as HTMLElement;

    const burgerMenu = document.querySelector(
        ".ux-iws-nav-burger"
    ) as HTMLElement;

    const lvl1Navigation = document.querySelector(
        ".ux-iws-nav__lvl1"
    ) as HTMLUListElement;

    if (type == "open") {
        if (header !== null) {
            header.classList.add("ux-iws-header--active");
        }
        if (dropdownContainer !== null) {
            dropdownContainer.classList.add(
                "ux-iws-header__dropdown-container--active"
            );
            handleOuterDropdownContainer(lvl1Navigation.offsetHeight);
        }
        burgerMenu.classList.add("ux-iws-nav-burger--active");
        lvl1Navigation.classList.add("ux-iws-nav__lvl1--active");
        handleContentOnActiveNavigation(level, type);
    } else {
        if (header !== null) {
            header.classList.remove("ux-iws-header--active");
        }
        if (dropdownContainer !== null) {
            dropdownContainer.classList.remove(
                "ux-iws-header__dropdown-container--active"
            );
        }
        burgerMenu.classList.remove("ux-iws-nav-burger--active");
        lvl1Navigation.classList.remove("ux-iws-nav__lvl1--active");
        handleContentOnActiveNavigation(level, type);
    }
}

export function handleContentOnActiveNavigation(level, type) {
    const body = document.body as HTMLElement;
    let levelNumber = Number(level);
    let classesAdd = [
        "ux-iws-nav-active",
        "ux-iws-nav-active--lvl-" + levelNumber,
    ];
    let classesRemove = [
        "ux-iws-nav-active",
        "ux-iws-nav-active--lvl-1",
        "ux-iws-nav-active--lvl-2",
        "ux-iws-nav-active--lvl-3",
    ];

    classesRemove.forEach(function (item) {
        body.classList.remove(item);
    });

    if (type == "open") {
        classesAdd.forEach(function (item) {
            body.classList.add(item);
        });
    }
}

export function handleOuterDropdownContainer(offset) {
    const dropdownContainer = document.querySelector(
        ".ux-iws-header__dropdown-container"
    ) as HTMLElement;
    const navigationHeight = 100;

    if (dropdownContainer !== null) {
        dropdownContainer.style.top = offset + navigationHeight + "px";
    }
}
